import { MarketplaceComponentConfig } from '@nocode/types';

export default {
  name: 'InvoicePDF',
  displayName: { ja: 'InvoicePDF', en: 'InvoicePDF' },
  resizeX: true,
  resizeY: true,
  props: [
    {
      name: 'items',
      displayName: {
        en: 'What is this a list of?',
        ja: 'データベースの選択',
      },
      type: 'list',
    },
    {
      name: 'onPress',
      displayName: {
        en: 'List',
        ja: 'リスト',
      },
      type: 'action',
      role: 'listItem',
      reference: 'items',
    },
    {
      name: 'currency',
      displayName: {
        en: 'Currency',
        ja: '通貨',
      },
      type: 'text',
      control: {
        type: 'menu',
        options: [
          {
            label: 'JPY',
            value: 'JPY',
          },
          {
            label: 'USD',
            value: 'USD',
          },
        ],
      },
    },
  ],
  childComponents: [
    {
      displayName: {
        en: 'Order lines',
        ja: '注文行',
      },
      name: 'orderLines',
      role: 'listItem',
      reference: 'items',
      props: [
        {
          name: 'itemName',
          displayName: {
            en: 'Item name',
            ja: '商品名',
          },
          type: 'text',
        },
        {
          name: 'itemDescription',
          displayName: {
            en: 'Item description',
            ja: '商品説明',
          },
          type: 'text',
        },
        {
          name: 'itemQuantity',
          displayName: {
            en: 'Item quantity',
            ja: '商品数量',
          },
          type: 'number',
        },
        {
          name: 'itemPrice',
          displayName: {
            en: 'Item price',
            ja: '商品価格',
          },
          type: 'number',
        },
      ],
    },
    {
      displayName: {
        en: 'Order title',
        ja: '注文タイトル',
      },
      name: 'orderHeaders',
      props: [
        {
          name: 'itemName',
          displayName: {
            en: 'Item name',
            ja: '商品名',
          },
          type: 'text',
        },
        {
          name: 'itemQuantity',
          displayName: {
            en: 'Quantity',
            ja: '数量',
          },
          type: 'text',
        },
        {
          name: 'itemPrice',
          displayName: {
            en: 'Item price',
            ja: '商品価格',
          },
          type: 'text',
        },
        {
          name: 'total',
          displayName: {
            en: 'Total',
            ja: '商品合計',
          },
          type: 'text',
        },
      ],
    },
    {
      displayName: {
        en: 'Tax',
        ja: '税',
      },
      name: 'tax',
      props: [
        {
          name: 'enabled',
        },
        {
          name: 'title',
          displayName: {
            en: 'Title',
            ja: 'タイトル',
          },
          type: 'text',
        },
        {
          name: 'value',
          displayName: {
            en: 'Value',
            ja: '値',
          },
          type: 'number',
        },
        {
          name: 'type',
          displayName: {
            en: 'Type',
            ja: 'タイプ',
          },
          type: 'text',
          control: {
            type: 'menu',
            options: [
              {
                label: 'Percentage',
                value: 'percentage',
              },
              {
                label: 'Amount',
                value: 'amount',
              },
            ],
          },
        },
      ],
    },
    {
      displayName: {
        en: 'Shipping fee',
        ja: '送料',
      },
      name: 'shippingFee',
      props: [
        {
          name: 'enabled',
        },
        {
          name: 'title',
          displayName: {
            en: 'Title',
            ja: 'タイトル',
          },
          type: 'text',
        },
        {
          name: 'value',
          displayName: {
            en: 'Value',
            ja: '値',
          },
          type: 'number',
        },
        {
          name: 'type',
          displayName: {
            en: 'Type',
            ja: 'タイプ',
          },
          type: 'text',
          control: {
            type: 'menu',
            options: [
              {
                label: 'Percentage',
                value: 'percentage',
              },
              {
                label: 'Amount',
                value: 'amount',
              },
            ],
          },
        },
      ],
    },
    {
      displayName: {
        en: 'Sender information',
        ja: '送信者情報',
      },
      name: 'senderInformation',
      props: [
        {
          name: 'title',
          displayName: {
            en: 'Title',
            ja: 'タイトル',
          },
          type: 'text',
        },
        {
          name: 'name',
          displayName: {
            en: 'Name',
            ja: '名前',
          },
          type: 'text',
        },
        {
          name: 'description',
          displayName: {
            en: 'Description',
            ja: '説明',
          },
          type: 'text',
        },
      ],
    },
    {
      displayName: {
        en: 'Receiver information',
        ja: '受取人情報',
      },
      name: 'receiverInformation',
      props: [
        {
          name: 'title',
          displayName: {
            en: 'Title',
            ja: 'タイトル',
          },
          type: 'text',
        },
        {
          name: 'name',
          displayName: {
            en: 'Name',
            ja: '名前',
          },
          type: 'text',
        },
        {
          name: 'description',
          displayName: {
            en: 'Description',
            ja: '説明',
          },
          type: 'text',
        },
      ],
    },
    {
      displayName: {
        en: 'Invoice information',
        ja: '請求書情報',
      },
      name: 'invoiceInformation',
      props: [
        {
          name: 'logo',
          displayName: {
            en: 'Logo',
            ja: 'ロゴ',
          },
          type: 'image',
        },
        {
          name: 'title',
          displayName: {
            en: 'Title',
            ja: 'タイトル',
          },
          type: 'text',
        },
        {
          name: 'invoiceID',
          displayName: {
            en: 'Invoice ID',
            ja: '請求書番号',
          },
          type: 'text',
        },
        {
          name: 'notes',
          displayName: {
            en: 'Notes',
            ja: '注記',
          },
          type: 'text',
        },
      ],
    },
    {
      displayName: {
        en: 'Custom fields 1',
        ja: 'カスタムフィールド1',
      },
      name: 'customFields1',
      props: [
        {
          name: 'enabled',
        },
        {
          name: 'title',
          displayName: {
            en: 'Title',
            ja: 'タイトル',
          },
          type: 'text',
        },
        {
          name: 'value',
          displayName: {
            en: 'Value',
            ja: '値',
          },
          type: 'text',
        },
      ],
    },
    {
      displayName: {
        en: 'Custom fields 2',
        ja: 'カスタムフィールド2',
      },
      name: 'customFields2',
      props: [
        {
          name: 'enabled',
        },
        {
          name: 'title',
          displayName: {
            en: 'Title',
            ja: 'タイトル',
          },
          type: 'text',
        },
        {
          name: 'value',
          displayName: {
            en: 'Value',
            ja: '値',
          },
          type: 'text',
        },
      ],
    },
    {
      displayName: {
        en: 'Custom fields 3',
        ja: 'カスタムフィールド3',
      },
      name: 'customFields3',
      props: [
        {
          name: 'enabled',
        },
        {
          name: 'title',
          displayName: {
            en: 'Title',
            ja: 'タイトル',
          },
          type: 'text',
        },
        {
          name: 'value',
          displayName: {
            en: 'Value',
            ja: '値',
          },
          type: 'text',
        },
      ],
    },
    {
      displayName: {
        en: 'Custom fields 4',
        ja: 'カスタムフィールド4',
      },
      name: 'customFields4',
      props: [
        {
          name: 'enabled',
        },
        {
          name: 'title',
          displayName: {
            en: 'Title',
            ja: 'タイトル',
          },
          type: 'text',
        },
        {
          name: 'value',
          displayName: {
            en: 'Value',
            ja: '値',
          },
          type: 'text',
        },
      ],
    },
  ],
} as MarketplaceComponentConfig;
